module.exports = __webpack_public_path__ + "img/firmas.5b515000.png";